import { defineComponent } from 'vue';
import { QTree } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'dynamic-tree-dsgn',
    mixins: [BaseComponentMixin],
    components: { QTree },
    data() {
        return {
            model: [],
            expandedKeys: [],
        };
    },
    async created() {
        if (this.controlData?.SourceType === 'Raw' && this.controlData.SourceRaw) {
            const raw = this.controlData.SourceRaw;
            this.model = Array.isArray(raw) ? raw : [];
        }
        else if (this.controlData?.SourceType === 'Url' && this.controlData.SourceUrl) {
            if (this.controlData.SourceUrl.includes('{'))
                this.model = [];
            else {
                try {
                    const res = await utils.api.get(this.controlData.SourceUrl);
                    this.model = Array.isArray(res) ? res : [];
                }
                catch (e) {
                    this.model = [];
                }
            }
        }
    },
    computed: {
        itemKey() {
            return this.controlData?.ItemKey || 'id';
        },
        itemText() {
            return this.controlData?.ItemText || 'name';
        },
        itemChildren() {
            return this.controlData?.ItemChildren || 'children';
        },
        dummyData() {
            const k = this.itemKey;
            const t = this.itemText;
            const c = this.itemChildren;
            return [
                {
                    [k]: 'Item0',
                    [t]: 'Value0',
                    [c]: [{ [k]: 'ChildItem0', [t]: 'ChildValue0' }],
                },
                {
                    [k]: 'Item1',
                    [t]: 'Value1',
                    [c]: [{ [k]: 'ChildItem1', [t]: 'ChildValue1' }],
                },
            ];
        },
        displayNodes() {
            const base =
                Array.isArray(this.model) && this.model.length > 0 ? this.model : this.dummyData;
            const ck = this.itemChildren;
            if (ck === 'children')
                return base;
            return this.mapTreeNodes(base, ck);
        },
    },
    methods: {
        mapTreeNodes(items, childKey) {
            if (!items || !Array.isArray(items))
                return [];
            const ik = this.itemKey;
            return items.map((n) => {
                const hasChildCollection = Array.isArray(n[childKey]);
                const children = hasChildCollection ? this.mapTreeNodes(n[childKey], childKey) : undefined;
                const hasChildren = !!(children && children.length);
                return {
                    ...n,
                    children,
                    selectable: !hasChildren,
                };
            });
        },
        collectParentKeys(nodes, keyProp) {
            const keys = [];
            for (const n of nodes || []) {
                if (n.children && n.children.length > 0) {
                    keys.push(n[keyProp]);
                    keys.push(...this.collectParentKeys(n.children, keyProp));
                }
            }
            return keys;
        },
    },
    watch: {
        displayNodes: {
            handler(nodes) {
                this.expandedKeys = this.collectParentKeys(nodes, this.itemKey);
            },
            immediate: true,
            deep: true,
        },
    },
    props: {
    },
    render() {
        try {
            if (!this.controlData)
                return null;

            const style = {
                ...utils.getStyleHints(this.controlData.StyleHints),
                ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
                minWidth: '25px',
                overflow: 'auto',
            };

            const itemKey = this.itemKey;
            const itemText = this.itemText;

            const renderHeader = ({ node }) => (
                <div
                    class="q-pa-xs row items-center no-wrap"
                    style={{ minWidth: 0, cursor: 'default' }}>
                    <span class="text-body2 ellipsis" style={{ flex: '1 1 0', minWidth: 0 }}>
                        {node[itemText]}
                    </span>
                </div>
            );

            const tv = (
                <QTree
                    nodes={this.displayNodes}
                    node-key={itemKey}
                    label-key={itemText}
                    noConnectors
                    dense
                    class="q-ma-xs c-DynamicTreeDsgn-tree"
                    style={{ backgroundColor: '#f2f2f2' }}
                    expanded={this.expandedKeys}
                    onUpdate:expanded={(keys) => { this.expandedKeys = keys; }}
                    v-slots={{ 'default-header': renderHeader }}
                />
            );

            return (
                <div
                    class={{
                        'c-DynamicTreeDsgn': true,
                        [`c-name-${this.name || 'unnamed'}`]: true,
                        'designer-container': true,
                        selected: this.selected$,
                    }}
                    style={style}
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />
                    {tv}
                </div>
            );
        }
        catch (e) {
            utils.error('DynamicTreeDsgn Render failed', e);
            return <div>DynamicTreeDsgn Failed to Render {String(e)}</div>;
        }
    },
});
